namespace Cfnc {
    'use strict'

    export class InstitutionMapper {
        static getMap() {
            var map = {
                8923: "Alamance-Community-College",
                5145: "Appalachian-State-University",
                5192: "Asheville--Buncombe-Technical-Community-College",
                5213: "Barton-College",
                5296: "Beaufort-County-Community-College",
                5309: "Belmont-Abbey-College",
                5319: "Bennett-College",
                5380: "Bladen-Community-College",
                5394: "Blue-Ridge-Community-College",
                5427: "Brevard-College",
                5458: "Brunswick-Community-College",
                7227: "Cabarrus-College-of-Health-Sciences",
                5487: "Caldwell-Community-College-and-Technical-Institute",
                5534: "Campbell-University",
                5547: "Cape-Fear-Community-College",
                5570: "Carteret-Community-College",
                5578: "Catawba-College",
                5579: "Catawba-Valley-Community-College",
                5608: "Central-Carolina-Community-College",
                5629: "Central-Piedmont-Community-College",
                5678: "Chowan-University",
                5763: "Cleveland-Community-College",
                5775: "Coastal-Carolina-Community-College",
                5845: "College-of-The-Albemarle",
                5992: "Craven-Community-College",
                6040: "Davidson-College",
                6041: "Davidson-County-Community-College",
                6146: "Duke-University",
                6151: "Durham-Technical-Community-College",
                6160: "East-Carolina-University",
                6215: "Edgecombe-Community-College",
                6233: "Elizabeth-City-State-University",
                6243: "Elon-University",
                6317: "Fayetteville-State-University",
                6318: "Fayetteville-Technical-Community-College",
                6370: "Forsyth-Technical-Community-College",
                6425: "Gardner--Webb-University",
                6429: "Gaston-College",
                6515: "Greensboro-College",
                6533: "Guilford-College",
                6534: "Guilford-Technical-Community-College",
                6545: "Halifax-Community-College",
                6582: "Haywood-Community-College",
                6636: "High-Point-University",
                6859: "Isothermal-Community-College",
                6916: "James-Sprunt-Community-College",
                1631: "9 Johnson-&-Wales-University",
                6951: "Johnson-C.-Smith-University",
                6954: "Johnston-Community-College",
                7138: "Lees--McRae-College",
                7144: "Lenoir--Rhyne-University",
                7143: "Lenoir-Community-College",
                7185: "Livingstone-College",
                7226: "Louisburg-College",
                7328: "Mars-Hill-University",
                7331: "Martin-Community-College",
                7366: "Mayland-Community-College",
                7373: "McDowell-Technical-Community-College",
                7418: "Meredith-College",
                7431: "Methodist-University",
                7538: "Mitchell-Community-College",
                7569: "Montgomery-Community-College",
                7570: "Montreat-College",
                7642: "Nash-Community-College",
                7790: "North-Carolina-Agricultural-and-Technical-State-University",
                7791: "North-Carolina-Central-University",
                7794: "North-Carolina-State-University",
                7795: "North-Carolina-Wesleyan-College",
                8048: "Pamlico-Community-College",
                8121: "Pfeiffer-University",
                8145: "Piedmont-Community-College",
                8166: "Pitt-Community-College",
                8223: "Queens-University-of-Charlotte",
                8252: "Randolph-Community-College",
                8304: "Richmond-Community-College",
                8318: "Roanoke--Chowan-Community-College",
                8325: "Robeson-Community-College",
                8332: "Rockingham-Community-College",
                8347: "Rowan--Cabarrus-Community-College",
                8400: "Saint-Augustine's-University",
                8504: "Salem-College",
                8514: "Sampson-Community-College",
                8521: "Sandhills-Community-College",
                8618: "Shaw-University",
                5128: "South-Piedmont-Community-College",
                8687: "Southeastern-Community-College",
                8770: "Southwestern-Community-College",
                8394: "St.-Andrews-University",
                8806: "Stanly-Community-College",
                8888: "Surry-Community-College",
                9010: "Tri--County-Community-College",
                7608: "University-of-Mount-Olive",
                9312: "University-of-North-Carolina-Asheville",
                9313: "University-of-North-Carolina-at-Chapel-Hill",
                9314: "University-of-North-Carolina-at-Charlotte",
                9315: "University-of-North-Carolina-at-Greensboro",
                8080: "University-of-North-Carolina-at-Pembroke",
                7793: "University-of-North-Carolina-School-of-the-Arts",
                9316: "University-of-North-Carolina-Wilmington",
                9507: "Vance--Granville-Community-College",
                9556: "Wake-Forest-University",
                9557: "Wake-Technical-Community-College",
                9573: "Warren-Wilson-College",
                9597: "Wayne-Community-College",
                9630: "Western-Carolina-University",
                9648: "Western-Piedmont-Community-College",
                9720: "Wilkes-Community-College",
                8077: "William-Peace-University",
                9740: "Wilson-Community-College",
                9742: "Wingate-University",
                9747: "Winston--Salem-State-University",

            }

            return map;
        }

    }

    angular.module("app").constant("institutionMapper", InstitutionMapper.getMap());
}